export const filterCondition = [
    {
        id: 1,
        title: 'Please Select...'
    },
    {
        id: 2,
        title: 'Equals'
    },
    {
        id: 3,
        title: 'Not Equals'
    },
    {
        id: 4,
        title: 'Greater than'
    },
    {
        id: 5,
        title: 'Greater than and equal to'
    },
    {
        id: 6,
        title: 'Less than'
    },
    {
        id: 7,
        title: 'Less than and equal to'
    },
    {
        id: 9,
        title: 'Start with'
    },
    {
        id: 10,
        title: 'End With'
    }
]

export const sortinCondition = [
    {
        id: 1,
        title: 'Please Select'
    },
    {
        id: 2,
        title: 'Ascending'
    },
    {
        id: 3,
        title: 'Descending'
    },
    {
        id: 4,
        title: 'A-Z'
    },
    {
        id: 5,
        title: 'Z-A'
    },
]